import { useRef, useState } from 'react'
import { mappedArray } from '@10000/common'
import { Box, CenteredBox, ElementHighlight, Icon, Timeline } from '../widgets'
import { useAnalyticsData } from '.'
import './PlaybackControls.scss'

// this is definitely not the recommended way
let playing = false

export const PlaybackControls = props => {
  const { squizzes, squiz, setSquiz, setTransition } = useAnalyticsData()
  const [playDuration, setPlayDuration] = useState()
  const controls = useRef()

  const disabled = squizzes.length <= 1
  const totalDuration = (squizzes.length - 1) * 1000
  const frames = mappedArray(squizzes.length, i => i === squizzes.length - 1 ? 0 : 1 / (squizzes.length - 1))

  const play = () => {
    playing = true
    setTransition(0)
    setSquiz(0)
    setPlayDuration(totalDuration)
    setTimeout(playNextFrame, 10)
  }

  const pause = () => playing = false

  const playNextFrame = () => setSquiz(squiz => {
    if(squiz < (squizzes.length - 1) && playing) {
      const frameDuration = frames[squiz] * totalDuration
      // needs to be shorter than the duration to allow the transition to complete before starting the next one
      setTransition((frameDuration - 25) / 1000)
      setTimeout(playNextFrame, frameDuration)
      return squiz + 1
    } else {
      setTransition(undefined)
      setPlayDuration(undefined)
      playing = false
      return squiz
    }
  })

  return (
    <CenteredBox className="playback" fullWidth {...props} r={24}>
      <CenteredBox className="playback-container" grow height={65} r={24}>
        <Box ref={controls} r={24}>
          <CenteredBox
            size={45}
            r="50%"
            background={disabled ? 'var(--darkgrey)' : playing ? 'var(--red)' : 'var(--blue)'}
            cursor={disabled || 'pointer'}
            onClick={disabled ? undefined : playing ? pause : play}
          >
            <Icon icon={playing ? 'Pause' : 'Play'} size={24} />
          </CenteredBox>
        </Box>
        <Timeline
          frames={frames}
          selectedNode={squiz}
          onNodeSelected={setSquiz}
          fullWidth
          playDuration={playDuration}
          maxWidth={620}
        />
      </CenteredBox>

      <ElementHighlight
        order={8}
        target={controls}
        pointDirection="left-down"
        nextOnFinish
      />
    </CenteredBox>
  )
}